<template>
  <div class="row">
    <div class="contents_area text_left">
      <div class="header_container">
        <h3 class="mb30">
          Sorry, <br>
          Payment has not been completed and<br>
          your account has not been charged.
        </h3>
        <h6 class="--grey80">
          Please restart payment or contact customer service.
        </h6>
      </div>
      <div class="mt100">
        <a
            @click="goBack()"
            class="regular-fill-button-blue70 mr10"
        >
          Start paying again
        </a>
        <a
            :href="`mailto:${this.mail}?Subject=[ERROR CODE]${this.resultProps.data.failedCode}`"
            class="regular-line-button-blue70"
        >
          Contact Customer Service
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {_SERVICE_MAIL} from "../../../../static";

export default {
  name: 'FailedView',
  props: {
    resultProps: Object
  },
  data() {
    return {
      mail: _SERVICE_MAIL,
    }
  },
  created() {
    if (!this.resultProps) {
      this.$router.go(-1);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>